import type { UserModule } from '~/types'
import { createPinia } from 'pinia'

export const install: UserModule = ({ isClient, app, initialState }) => {
  const pinia = createPinia()
  app.use(pinia)

  // https://github.com/antfu/vite-ssg/blob/main/README.md#state-serialization
  // for other serialization strategies.
  if (isClient) {
    pinia.state.value = initialState.pinia || {}
  } else {
    initialState.pinia = pinia.state.value
  }
}
